import { createClient } from '@supabase/supabase-js'



const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase credentials:', {
    hasUrl: !!supabaseUrl,
    hasKey: !!supabaseAnonKey
  })
  throw new Error('Missing Supabase credentials')
}

// Create a single instance
let supabaseInstance: ReturnType<typeof createClient> | null = null

export const supabase = (() => {
  if (!supabaseInstance) {
    supabaseInstance = createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        storage: {
          getItem: (key: string) => {
            if (typeof window === 'undefined') {
              return null;
            }

            try {
              return localStorage.getItem(key);
            } catch (error) {
              console.warn('[SupabaseStorage] Failed to read from localStorage', error);
              return null;
            }
          },
          setItem: (key: string, value: string) => {
            if (typeof window === 'undefined') {
              return;
            }

            try {
              localStorage.setItem(key, value);
            } catch (error) {
              console.warn('[SupabaseStorage] Failed to write to localStorage', error);
            }
          },
          removeItem: (key: string) => {
            if (typeof window === 'undefined') {
              return;
            }

            try {
              localStorage.removeItem(key);
            } catch (error) {
              console.warn('[SupabaseStorage] Failed to remove from localStorage', error);
            }
          }
        }
      }
    })
  }
  return supabaseInstance
})() 
